import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appExpandContent]',
  standalone: true,
})
export class ExpandContentDirective {
  readonly templateRef = inject(TemplateRef<unknown>);
}
